import React from 'react';
import GoogleClassroomItem from '../GoogleClassroomItem/GoogleClassroomItem';

const GoogleClassroomList = ({ t, loadingClass, classes, onChangeSelected, onChangeSelectedStudents }) => {
  return (
    <ul className="google-clasroom-list">
      {classes.map((theClass) => {
        return (
          <GoogleClassroomItem
            t={t}
            loadingClass={loadingClass}
            key={theClass.id}
            guid={theClass.id}
            name={theClass.name}
            students={theClass.students}
            selected={theClass.active}
            onChangeSelected={onChangeSelected}
            onChangeSelectedStudents={onChangeSelectedStudents}
          />
        );
      })}
    </ul>
  );
};

GoogleClassroomList.defaultProps = {
  classes: [],
};

export default GoogleClassroomList;
